/**
 * Enum for UploadErrorTypes
 * @readonly
 * @enum {string}
 */
export const UploadErrorTypes = {
    GET_POLICY: 'GetPolicy',
    UPLOAD_FILE: 'UploadFile',
    CREATE_PENDING_ATTACHMENT: 'CreatePendingAttachment'
};
